import { AbstractReportPmsApiService } from '../abstract-report.service';

/**
 * @class DailyFinancialPmsApiService
 * @extends {AbstractReportPmsApiService<DailyFinancial>}
 */
export class DailyFinancialPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/financial/daily-financial';
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<Object>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/financial/daily-financial-report.service.js